export default "__VITE_ASSET__DSrtWv____"